import React from "react";
import Logo from '../../../resources/images/logo.svg';
import iTIALogo from '../../../resources/images/itia-logo.svg';
import './index.scss';
import WidgetContext from '../../../context/WidgetContext';
import {APP_CLIENTS} from '../../../utils/constants';
const { REACT_APP_CLIENT } = process.env;

const Header = () => {
  const getHeaderLogo=()=>{
    if(REACT_APP_CLIENT===APP_CLIENTS.lighthouse){
      return Logo;
    }else if(REACT_APP_CLIENT===APP_CLIENTS.uber){
      return iTIALogo;
    }
  }
  return (
    <WidgetContext.Consumer >
      {
        context => (
          <div className="topnav" >
            <img src={getHeaderLogo()} className="logo" />
            <div>{(context.isWidgetOpen && !context.isCloseClicked) && <span onClick={()=>context.toggleWidgetContext(true, true)} className="close-btn" title="Close">&times;</span>}</div>
          </div>
        )
      }
    </WidgetContext.Consumer> 
  );
}

export default Header;